<template>

    <div class="delivery-info small">

        <div class="text-info mt-1 delivery-info-supplier">
            {{ __('Verkauf & Versand durch :supplier', {supplier: product.supplier.short_name}) }}
        </div>
        
        <div class="mt-1 fw-bold text-success" v-if="product.free_delivery">
            {{ __('versandkostenfrei') }}
        </div>

        <div class="mt-1" v-if="product.manage_stock">

            <span v-if="product.stock_quantity === 0 && !product.supplier.account_options.allow_order_despite_empty_stock" class="text-danger">
                <i class="bi bi-circle-fill"></i>
                {{ __('Nicht auf Lager') }}
            </span>

            <span v-else-if="product.stock_quantity > 0" class="text-success">
                <i class="bi bi-circle-fill"></i>
                <span>
                    {{ __('Auf Lager') }}
                </span>
                <span v-if="product.delivery_time" class="text-success d-block">
                    {{ __n('Gewöhnlich in einem Werktag|Gewöhnlich in :days Werktagen', 1, {days: product.delivery_time}) }}
                </span>
            </span>

        </div>

    </div>

</template>

<script>
    export default {
        props: [
            'product',
        ],
    }
</script>